export const BACK = 'BACK'
export const FADE = 'FADE'
export const NEXT = 'NEXT'
export const SCALE_IN = 'SCALE_IN'
export const SLIDE_NEXT = 'SLIDE_NEXT'
export const SLIDE_PREV = 'SLIDE_PREV'
export const SLIDE_UP = 'SLIDE_UP'
export const SLIDE_DOWN = 'SLIDE_DOWN'
